import React, { useState, useEffect } from "react";

import Header from "../../components/header/header";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useNavigate, useLocation } from "react-router-dom";
import "./pickupInfo.css";
import BookingFooter from "../../components/bookingFooter/bookingFooter";
import RideSummary from "../../components/rideSummary/rideSummary";

const PickupInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const receivedData = location.state || {};
  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [isSameAsPhone, setIsSameAsPhone] = useState(false);
  const [email, setEmail] = useState("");
  const [notesForChauffeur, setNotesForChauffeur] = useState("");
  const [flightNumber, setFlightNumber] = useState("");
  const [errors, setErrors] = useState({
    phoneNumber: "",
    name: "",
    email: "",
    whatsappNumber: "",
  });

  const handleCopyPhoneNumber = () => {
    setIsSameAsPhone(!isSameAsPhone);
    if (!isSameAsPhone) {
      setWhatsappNumber(phoneNumber);
      setErrors((prevErrors) => ({ ...prevErrors, whatsappNumber: "" }));
    } else {
      setWhatsappNumber("");
    }
  };

  const validateFields = () => {
    let newErrors = {};

    // Phone number validation
    if (!phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    }

    // Name validation
    if (!name) {
      newErrors.name = "Name is required";
    }

    // Email validation
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // WhatsApp number validation
    if (!whatsappNumber) {
      newErrors.whatsappNumber = "WhatsApp number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e, field) => {
    const value = e.target.value;

    // Remove error if value is entered (non-null)
    if (value) {
      setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
    }

    // Map field names to corresponding setter functions
    const fieldSetters = {
      name: setName,
      phoneNumber: setPhoneNumber,
      email: setEmail,
      whatsappNumber: setWhatsappNumber,
    };

    // Update the corresponding field using the setter function
    if (fieldSetters[field]) {
      fieldSetters[field](value);
    }
  };

  const onContinueClick = () => {
    if (!validateFields()) return;
    receivedData.customerPhoneNumber = phoneNumber;
    receivedData.customerName = name;
    receivedData.customerEmail = email;
    receivedData.customerWhatsappNumber = whatsappNumber;
    receivedData.flightNumber = flightNumber;
    receivedData.notesForChauffeur = notesForChauffeur;
    receivedData.luggageCount = "2";
    receivedData.passengerCount = "2";
    navigate("/payment", { state: receivedData });
  };
  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY; // Get the current scroll position
      const element = document.querySelector("header");
      if (element) {
        if (scroll >= 10) {
          element.classList.add("lightHeader");
          //   document.body.classList.add("dark");
        } else {
          document.querySelector("header").classList.remove("lightHeader");
          //   document.body.classList.remove("dark");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Cleanup the event listener on unmount
    };
  }, []);
  return (
    <>
      <Header></Header>
      <div className="content_">
        {/* Content Inner */}
        <div className="content__inner">
          <div className="overflow-hidden">
            {/* Multi-steps Form */}
            <div className="multisteps-form">
              <div className="progress-row">
                {/* Progress Bar */}
                <div className="row">
                  <div className="col-12 col-lg-12 ml-auto mr-auto mb-4 mt-5">
                    <div className="multisteps-form__progress flex space-x-4">
                      <button
                        className="multisteps-form__progress-btn  js-active bg-blue-500 text-white py-2 px-4 rounded"
                        type="button"
                        title="Service Class"
                      >
                        <span>Service Class</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn js-active  bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Pickup Info"
                      >
                        <span>Pickup Info</span>
                      </button>
                      {/* Commented Button */}
                      {/* <button className="multisteps-form__progress-btn" type="button" title="Log In">
                    <span>Log In</span>
                </button> */}
                      <button
                        className="multisteps-form__progress-btn  bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Payment"
                      >
                        <span>Payment</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Thankyou"
                      >
                        <span>Thank You</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-8 m-auto">
                  <form class="multisteps-form__form">
                    <div
                      className="multisteps-form__panel rounded js-active"
                      data-animation="scaleIn"
                    >
                      <div className="step_details mb-5">
                        <input
                          type="hidden"
                          name="vehicleType"
                          id="vehicleType"
                          value="Comfort"
                        />
                        <RideSummary
                          pickup={receivedData.pickupLocation}
                          destination={receivedData.dropOffLocation}
                          pickupDate={receivedData.pickupDate}
                          pickupTime={receivedData.pickupTime}
                          distDurationValue={receivedData.distDurationValue}
                        ></RideSummary>
                        <h3 className="additional-heading mt-4 mb-3">
                          Customer Details
                        </h3>

                        <div className="pickup-sign border rounded p-3 mt-4 d-none someone-else-form">
                          <div className="input-block mb-0">
                            <div className="value_wrapper">
                              <span className="label-box">Full name *</span>
                              <input
                                className="inputElement"
                                type="text"
                                name="customerName"
                                onChange={(e) => handleInputChange(e, "name")}
                                required
                              />
                            </div>
                          </div>
                          {errors.name && (
                            <span
                              className="error-text"
                              style={{
                                color: "#cc434c",
                                padding: "4px 16px 0",
                                fontSize: "14px",
                              }}
                            >
                              {errors.name}
                            </span>
                          )}
                          <p className="note-p mb-3">
                            It will appear on your chauffeur's pickup sign when
                            they meet you.
                          </p>

                          <div className="input-block mb-0">
                            <div className="value_wrapper">
                              <span className="label-box">Email*</span>
                              <input
                                className="inputElement"
                                type="email"
                                name="customerEmail"
                                onChange={(e) => handleInputChange(e, "email")}
                                required
                              />
                            </div>
                          </div>
                          {errors.email && (
                            <span
                              className="error-text"
                              style={{
                                color: "#cc434c",
                                padding: "4px 16px 0",
                                fontSize: "14px",
                              }}
                            >
                              {errors.email}
                            </span>
                          )}
                          <p className="note-p mb-3">
                            It will appear on your chauffeur's pickup sign when
                            they meet you.
                          </p>

                          <div
                            className="input-block mb-0 country-field"
                            onClick={() =>
                              document
                                .querySelector(".custom-phone-input")
                                ?.focus()
                            }
                          >
                            <div className="value_wrapper">
                              <span className="label-box">Phone Number*</span>
                              {/* <input
                                id="phoneNumber"
                                className="inputElement"
                                type="tel"
                                placeholder="Enter your phone number"
                                value={phoneNumber}
                                onChange={(e) =>
                                  handleInputChange(e, "phoneNumber")
                                }
                                required
                              /> */}
                              <PhoneInput
                                international
                                defaultCountry="AE" // Default country set to UAE (+971)
                                value={phoneNumber || null}
                                onChange={setPhoneNumber}
                                placeholder="Enter phone number"
                                required
                                className="custom-phone-input"
                                style={{
                                  border: "none",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                              />
                            </div>
                          </div>
                          {errors.phoneNumber && (
                            <span
                              className="error-text"
                              style={{
                                color: "#cc434c",
                                padding: "4px 16px 0",
                                fontSize: "14px",
                              }}
                            >
                              {errors.phoneNumber}
                            </span>
                          )}
                          <p className="note-p mb-3">
                            It will appear on your chauffeur's pickup sign when
                            they meet you.
                          </p>

                          <div className="checkbox-block mb-2 mt-1">
                            <input
                              type="checkbox"
                              id="sameAsPhone"
                              style={{
                                verticalAlign: "middle",
                                marginRight: "2px",
                              }}
                              checked={isSameAsPhone}
                              onChange={handleCopyPhoneNumber}
                            />
                            <label
                              htmlFor="sameAsPhone"
                              style={{ fontSize: "14px" }}
                            >
                              WhatsApp number is the same as phone number
                            </label>
                          </div>

                          <div
                            className="input-block mb-0 country-field"
                            onClick={() =>
                              document
                                .querySelector(".custom-whatsapp-phone-input")
                                ?.focus()
                            }
                          >
                            <div className="value_wrapper">
                              <span className="label-box">
                                WhatsApp Number*
                              </span>
                              {/* <input
                                id="whatsappNumber"
                                className="inputElement"
                                type="tel"
                                placeholder="Enter your WhatsApp number"
                                value={whatsappNumber}
                                onChange={(e) =>
                                  handleInputChange(e, "whatsappNumber")
                                }
                                required
                              /> */}
                              <PhoneInput
                                international
                                defaultCountry="AE" // Default country set to UAE (+971)
                                value={whatsappNumber || null}
                                onChange={setWhatsappNumber}
                                placeholder="Enter whatsapp number"
                                required
                                className="custom-whatsapp-phone-input"
                                style={{
                                  border: "none",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                              />
                            </div>
                          </div>
                          {errors.whatsappNumber && (
                            <span
                              className="error-text"
                              style={{
                                color: "#cc434c",
                                padding: "4px 16px 0",
                                fontSize: "14px",
                              }}
                            >
                              {errors.whatsappNumber}
                            </span>
                          )}
                        </div>

                        <h3 className="additional-heading mt-4">
                          Provide additional information
                        </h3>
                        <p className="additional-note">
                          Enter your flight number to ensure your chauffeur can
                          track your flight and adjust the pickup time.
                        </p>

                        <div className="all_include">
                          <div className="input-block mb-0">
                            <div className="value_wrapper">
                              <span className="label-box">Flight number</span>
                              <input
                                className="inputElement"
                                type="text"
                                name="flightNumber"
                                onChange={(e) =>
                                  setFlightNumber(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <p className="note-p mb-0">
                            e.g. LH 202, U24567, BA2490
                          </p>
                        </div>

                        <div className="pickup-sign border rounded p-3 mt-4">
                          <div className="input-block textarea-box mb-0">
                            <div className="value_wrapper">
                              <span className="label-box">
                                Notes for the chauffeur
                              </span>
                              <textarea
                                className="inputElement"
                                name="notesForChauffeur"
                                placeholder="Add special requests, e.g. number of bags, child seats, etc."
                                onChange={(e) =>
                                  setNotesForChauffeur(e.target.value)
                                }
                              ></textarea>
                            </div>
                          </div>
                          <p className="note-p mb-3">
                            Add special requests, e.g. number of bags, child
                            seats, etc. Please do not include confidential
                            information
                          </p>
                        </div>
                      </div>
                      <BookingFooter
                        onContinueClick={() => onContinueClick()}
                      ></BookingFooter>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PickupInfo;
